// src/components/dataone/OEMOptionsTable.tsx
import React from 'react';

interface OEMOption {
  group: string;
  category: string;
  name: string;
  code: string;
  description: string;
  invoice: string;
  msrp: string;
  installed: string;
}

export default function OEMOptionsTable({ options }: { options: OEMOption[] }) {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold">OEM Options</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left border border-gray-300 rounded">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-3 py-2">Group</th>
              <th className="px-3 py-2">Category</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">MSRP</th>
              <th className="px-3 py-2">Invoice</th>
              <th className="px-3 py-2">Installed</th>
            </tr>
          </thead>
          <tbody>
            {options.map((opt, index) => (
              <tr key={index} className="border-t">
                <td className="px-3 py-1">{opt.group}</td>
                <td className="px-3 py-1">{opt.category}</td>
                <td className="px-3 py-1">{opt.name}</td>
                <td className="px-3 py-1">${opt.msrp || '-'}</td>
                <td className="px-3 py-1">${opt.invoice || '-'}</td>
                <td className="px-3 py-1">{opt.installed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
